const PRODUCTION_HOST = 'estacoes.vammo.com';

/* cactus builds develop and production from the same Dockerfile and forwards no build
   args, so both ship an identical bundle and only the host tells them apart at runtime.
   Everything that is not the canonical host is treated as a test surface. */
export const isProductionHost = (hostname: string): boolean => hostname === PRODUCTION_HOST;
